import { create } from 'zustand';

export const useNotificationsStore = create((set, get) => ({
  // State
  notifications: [],
  isLoading: false,
  lastFetched: null,
  
  // Methods
  getNotifications: () => {
    return get().notifications;
  },
  
  getNotificationsCount: () => {
    return get().notifications.length;
  },
  
  // Transform API data to match component expectations
  transformNotificationData: (apiData) => {
    if (!apiData || !Array.isArray(apiData)) return [];
    
    return apiData.map(item => ({
      id: item.id.toString(),
      message: item.mensaje,
      createdAt: item.fecha_creacion,
      read: item.leida === 1,
      type: item.tipo || 'info',
      usuario_id: item.usuario_id,
      prioridad: item.prioridad
    }));
  },

  // Initialize notifications from user's initial data (when app launches)
  initializeFromUserData: (userInitData) => {
    if (userInitData && Array.isArray(userInitData)) {
      const transformedNotifications = get().transformNotificationData(userInitData);
      set({ 
        notifications: transformedNotifications,
        isLoading: false,
        lastFetched: new Date().toISOString()
      });
      return true;
    }
    return false;
  },
  
  setNotificationRead: async (notificationId, fetchAPI) => {
    try {
      set({ isLoading: true });
      
      // Call the API to mark notification as read
      return new Promise((resolve) => {
        fetchAPI({
          section: 'notificaciones',
          action: 'Remove',
          params: {
            id: notificationId,
            /*
            //The notification is deleted when read
            data: {
              leida: 1,
              fecha_lectura: new Date().toISOString().slice(0, 19).replace('T', ' ')
            }
            */
          },
          OnLoaded: (success, payload) => {
            if (success) {
              // Remove the notification from the local store
              set((state) => ({
                notifications: state.notifications.filter(
                  (notification) => notification.id !== notificationId
                ),
                isLoading: false
              }));
              resolve(true);
            } else {
              console.error('Error marking notification as read:', payload);
              set({ isLoading: false });
              resolve(false);
            }
          },
          loadingMessage: 'Marcando notificación como leída...',
          showSuccessNotificationModal: false,
          showErrorNotificationModal: true
        });
      });
    } catch (error) {
      console.error('Error marking notification as read:', error);
      set({ isLoading: false });
      return false;
    }
  },
  
  fetchNotifications: async (fetchAPI, userId) => {
    try {
      set({ isLoading: true });
      
      return new Promise((resolve) => {
        fetchAPI({
          section: 'notificaciones',
          action: 'GetNotifications',
          params: {},
          OnLoaded: (success, payload) => {
            if (success && payload.notifications) {
              const transformedNotifications = get().transformNotificationData(payload.notifications);
              set({ 
                notifications: transformedNotifications,
                isLoading: false,
                lastFetched: new Date().toISOString()
              });
              resolve(true);
            } else {
              console.error('Error fetching notifications:', payload);
              set({ 
                notifications: [],
                isLoading: false 
              });
              resolve(false);
            }
          },
          loadingMessage: 'Cargando notificaciones...',
          showSuccessNotificationModal: false,
          showErrorNotificationModal: true
        });
      });
    } catch (error) {
      console.error('Error fetching notifications:', error);
      set({ 
        notifications: [],
        isLoading: false 
      });
      return false;
    }
  },
  
  // Initialize periodic fetch - this would be used in a component useEffect
  // TODO: set value to 60000 
  initFetchInterval: (fetchAPI, userId, intervalMs = 1000000) => {
    const intervalId = setInterval(() => {
      get().fetchNotifications(fetchAPI, userId);
    }, intervalMs);
    
    return intervalId; // Return so it can be cleared when needed
  },
  
  // Reset the entire store (used on logout)
  resetStore: () => {
    set({ 
      notifications: [], 
      isLoading: false, 
      lastFetched: null 
    });
    console.log('[NotificationsStore] Store reset on logout');
  }
}));

export default useNotificationsStore;
